<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <saa-s-child-page-container
    :use-return="userId.length>0"
    class="d-flex justify-center align-center"
    @back="back"
  >
    <template #title>
      <div class="text-h3">
        {{ $t('WelcomeByAaden') }}
      </div>
      <div class="text-body-1 mt-6 text--secondary">
        {{ $t('AadenSelectProductHelp') }}
      </div>
    </template>
    <template #actions>
      <next-step-button
        class="btnContentSelect"
        @next="start"
      >
        {{ $t('Start') }}
      </next-step-button>
      <div class="btnContentSelect mt-2">
        <v-btn
          color="info lighten-4 black--text"
          elevation="0"
          large
          @click="goToTrial"
        >
          <slot>
            {{ $t('startToTrial') }}
          </slot>
          <v-icon right>
            mdi-arrow-right
          </v-icon>
        </v-btn>
      </div>
    </template>
    <div
      class="d-flex flex-column text-caption"
      style="width: 100%;position: absolute;left: 0;right: 0;bottom: 20vh;"
    >
      <div class="d-flex justify-center align-center">
        <v-card
          class="pa-2"
          color="transparent"
          elevation="0"
          @click="bindOldDevice"
        >
          <span class="text--secondary">
            {{ $t('BindOldDevice') }}
          </span>
        </v-card>
        |
        <v-card
          class="pa-2"
          color="transparent"
          elevation="0"
          @click="signOut"
        >
          <span class="text--secondary">
            {{ $t('Logout') }}
          </span>
        </v-card>
      </div>
    </div>
  </saa-s-child-page-container>
</template>

<script>
import { dragscroll } from 'vue-dragscroll/src/main'
import NextStepButton from '@/views/SaaS/widget/NextStepButton.vue'
import { getCurrentSaaSOrderInfo, resetOrder } from '@/views/SaaS/SaaSGuide'
import { getCurrentUserId } from '@/model/dataLayer/api/SaaS/user'
import { getAllStoreIdForUser } from '@/model/dataLayer/api/SaaS/subscriptionService'
import { FireBaseAuth } from '@/model/firebase/google-fire-base'
import SaaSChildPageContainer from '@/views/SaaS/widget/SaaSChildPageContainer.vue'
import { loadProducts } from '@/model/dataLayer/api/SaaS/product'
import { checkTrialCode, doPayment } from '@/model/dataLayer/api/SaaS/SaaSUtils'
import IKUtils from 'innerken-js-utils'

export default {
  name: 'SaaSGuide',
  components: { SaaSChildPageContainer, NextStepButton },
  directives: {
    dragscroll
  },
  props: {},
  data: function () {
    return {
      waitJumpToPay: false,
      userId: ''
    }
  },
  computed: {},
  watch: {},
  async mounted () {
    this.userId = (await getAllStoreIdForUser(getCurrentUserId()))
  },
  methods: {
    getCorrectPriceForProduct (product, overrideMonthly = null) {
      const isOneTime = product.prices.some(it => it.type === 'one_time')
      const monthly = overrideMonthly ?? this.billedMonthly
      if (isOneTime) {
        product.prices[0].count = product.count ?? 1
        product.prices[0].realTotalPrice = product.prices[0].count * product.prices[0].unit_amount
        return product.prices[0]
      } else {
        if (monthly) {
          return product.prices.find(it => it.interval === 'month')
        } else {
          return product.prices.find(it => it.interval !== 'month')
        }
      }
    },
    async goToTrial () {
      const enProducts = await loadProducts(1)
      const enNeedToBuyProductsList = enProducts.filter(it => it.metadata.code === 'base')
      enNeedToBuyProductsList.forEach(it => {
        it.realPrice = this.getCorrectPriceForProduct(it)
      })
      const codeList = enNeedToBuyProductsList.map(it => it.metadata.code)
      const trialDate = await checkTrialCode(codeList)
      if (trialDate) {
        IKUtils.showLoading(true)
        const result = await doPayment(
          enNeedToBuyProductsList,
          getCurrentSaaSOrderInfo().storeId,
          trialDate)
        if (result) {
          location.reload()
        }
      } else {
        IKUtils.showError(this.$t('WrongTrialCode'))
      }
    },
    async signOut () {
      await FireBaseAuth.signOut()
      location.reload()
    },
    async bindOldDevice () {
      this.waitJumpToPay = true
      await this.$router.push({ name: 'ActiveStore' })
      this.waitJumpToPay = false
    },
    back () {
      this.$router.push({ name: 'PersonalInfoPage' })
    },
    start () {
      this.$router.push({ name: 'choose-store-type' })
      resetOrder()
    }
  }
}
</script>

<style scoped>

</style>
